"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import { FileQuestion } from "lucide-react";

export interface PageEmptyStateProps {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  className?: never;
}

export function PageEmptyState({
  icon,
  title,
  description,
  action,
  className,
}: PageEmptyStateProps) {
  return (
    <div
      className={cn(
        "flex min-h-[40vh] flex-col items-center justify-center gap-5 px-4 py-16",
        className
      )}
    >
      <div className="flex h-24 w-24 items-center justify-center rounded-full bg-slate-100 dark:bg-zinc-800">
        {icon || (
          <FileQuestion className="h-12 w-12 text-slate-400 dark:text-zinc-500" />
        )}
      </div>
      {title && (
        <h2 className="text-center text-lg font-semibold text-slate-900 dark:text-white">
          {title}
        </h2>
      )}
      {description && (
        <p className="max-w-md text-center text-sm text-slate-600 dark:text-zinc-400">
          {description}
        </p>
      )}
      {action && <div className="pt-2">{action}</div>}
    </div>
  );
}
